import { Row, Col }  from 'react-grid-system';
import ContentLoader from 'react-content-loader';
import { Box } from './ui';

interface FuturaTokenLoadingProps {
  size: number;
  leftSectionHeight: string;
}

const FuturaTokenLoading = ({ size, leftSectionHeight }: FuturaTokenLoadingProps) => {
  return (
    <Row>
      <Col xs={12} sm={6} md={5}>
          <Box
            width="100%"
            backgroundColor="black"
            height={leftSectionHeight}
            padding={['24px 8px', '24px']}
          >
          <ContentLoader
            speed={2}
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            backgroundColor="#333"
            foregroundColor="#999"
          >
            <rect x="0" y="0" rx="8" ry="8" width={size} height={size} />
          </ContentLoader>
        </Box>
      </Col>

      <Col xs={12} sm={6} md={7}>
        <Box padding={['24px 8px', '24px']}>
          <ContentLoader
            speed={2}
            width="1200"
            height="1200"
            viewBox="0 0 1200 1200"
            backgroundColor="#333"
            foregroundColor="#999"
          >
            <rect x="0" y="0" rx="8" ry="8" width="80px" height="20" />
            <rect x="0" y="36" rx="8" ry="8" width="600px" height="80" />
            <rect x="0" y="126" rx="8" ry="8" width="600px" height="80" />
          </ContentLoader>
        </Box>
      </Col>
    </Row>
  );
}

export default FuturaTokenLoading;
